import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Clock, Building2 } from 'lucide-react';
import { footerLinks } from '../../data/mockData';
import { companyInfo } from '../../data/content';
import { trackPhoneClick } from '../../lib/analytics';

export default function Footer() {
  return (
    <footer className="bg-[#2c3e50] text-white">
      <div className="max-w-[100rem] mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Logo & Description */}
          <div>
            <Link to="/" className="flex items-center gap-0 mb-4">
              <span className="flex items-center justify-center w-8 h-8 rounded-full border-2 border-white/80 text-white font-heading font-bold text-lg">
                W
              </span>
              <span
                className="text-white font-paragraph text-lg tracking-tight"
                style={{ marginLeft: '1px' }}
              >
                ebnatak
              </span>
            </Link>
            <p className="text-white/60 font-paragraph text-sm leading-relaxed mb-4">
              Profesjonalne strony internetowe w abonamencie. Bez opłat startowych, z pełną
              opieką techniczną.
            </p>
            <div className="text-xs text-white/50 font-paragraph space-y-1">
              <p className="flex items-start gap-2">
                <Building2 size={14} className="mt-0.5 shrink-0" />
                <span>
                  {companyInfo.legalName}
                  <br />
                  NIP: {companyInfo.nip}
                  <br />
                  REGON: {companyInfo.regon}
                </span>
              </p>
            </div>
          </div>

          {/* Strona */}
          <div>
            <h3 className="text-base font-heading font-semibold mb-4">Strona</h3>
            <ul className="space-y-2">
              {footerLinks.product.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-white/60 hover:text-white font-paragraph text-sm transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Usługi */}
          <div>
            <h3 className="text-base font-heading font-semibold mb-4">Usługi</h3>
            <ul className="space-y-2">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-white/60 hover:text-white font-paragraph text-sm transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
            <h3 className="text-base font-heading font-semibold mt-6 mb-3">Dokumenty</h3>
            <ul className="space-y-2">
              {footerLinks.legal.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-white/60 hover:text-white font-paragraph text-sm transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Kontakt */}
          <div>
            <h3 className="text-base font-heading font-semibold mb-4">Kontakt</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-white/60 text-sm font-paragraph">
                <Mail size={16} className="text-white/40 shrink-0 mt-0.5" />
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="hover:text-white transition-colors"
                >
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2 text-white/60 text-sm font-paragraph">
                <Phone size={16} className="text-white/40 shrink-0 mt-0.5" />
                <a
                  href={`tel:${companyInfo.phoneDigits}`}
                  onClick={trackPhoneClick}
                  className="hover:text-white transition-colors"
                >
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-2 text-white/60 text-sm font-paragraph">
                <MapPin size={16} className="text-white/40 shrink-0 mt-0.5" />
                <span>
                  {companyInfo.street}
                  <br />
                  {companyInfo.postalCode} {companyInfo.city}
                </span>
              </li>
              <li className="flex items-start gap-2 text-white/60 text-sm font-paragraph">
                <Clock size={16} className="text-white/40 shrink-0 mt-0.5" />
                <span>{companyInfo.workingHours}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-white/10">
        <div className="max-w-[100rem] mx-auto px-6 py-6 flex flex-col sm:flex-row gap-3 items-center justify-between">
          <p className="text-white/40 text-sm font-paragraph">
            © 2026 {companyInfo.name}. Wszystkie prawa zastrzeżone.
          </p>
          <div className="flex gap-4 text-xs text-white/40 font-paragraph">
            <Link to="/polityka-prywatnosci" className="hover:text-white/60">
              Polityka prywatności
            </Link>
            <Link to="/regulamin" className="hover:text-white/60">
              Regulamin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
